
export class AppError {
    constructor(public originalError?: any) {}
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/PROD-mufit-web/src/app/pages/common/app-error.ts